import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Vue CLI requires the VUE_APP_ prefix for env variables to be embedded
// into the client bundle. We access them via process.env.
// The distinction between dev/prod values comes from the build environment
// (local .env vs. Vercel env vars)

let appInstance = null;
let auth = null;
let firebaseInitializationPromise = null;

async function initializeFirebase() {
  // Only log verbose messages in development
  if (process.env.NODE_ENV !== 'production') {
    console.log('Attempting to fetch Firebase config...');
  }
  try {
    const response = await fetch('/api/firebase-config'); // Fetch from the serverless function
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Failed to fetch Firebase config: ${response.status} ${response.statusText} - ${errorData.error || ''}`);
    }
    const firebaseConfig = await response.json();

    appInstance = initializeApp(firebaseConfig);
    auth = getAuth(appInstance);
    // Only log verbose messages in development
    if (process.env.NODE_ENV !== 'production') {
      console.log('Firebase initialized successfully.');
    }
    return { appInstance, auth }; // Return the initialized instances

  } catch (error) {
    console.error('Firebase initialization failed:', error); // Keep error logging for prod
    // Handle the error appropriately - maybe show a message to the user
    // or prevent parts of the app from loading.
    appInstance = null; // Ensure instances are null on failure
    auth = null;
    throw error; // Re-throw the error so callers know initialization failed
  }
}

// Export a function that returns a promise resolving with the initialized instances
// This ensures that other parts of your app wait for initialization.
function getFirebaseInstances() {
    if (!firebaseInitializationPromise) {
        firebaseInitializationPromise = initializeFirebase();
    }
    return firebaseInitializationPromise;
}


// Export the function to get instances, not the potentially null instances directly
export { getFirebaseInstances };

// You might also export the potentially null instances for non-critical synchronous access,
// but be aware they might be null initially. Using getFirebaseInstances is safer.
export { appInstance, auth };